import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

enum $fields {
  forceGet = 'forceGet',
}

@Component({
  selector: 'app-scan-force-get',
  templateUrl: './scan-force-get.component.html',
  standalone: false,
})
export class ScanForceGetComponent {
  @Input()
  public form: UntypedFormGroup;

  public forceGetControlName: $fields = $fields.forceGet;

  constructor(private formBuilder: UntypedFormBuilder) {}

  @Input()
  public set forceGet(forceGet: boolean) {
    if (this.form) {
      this.form.registerControl(this.forceGetControlName, this.formBuilder.control(Boolean(forceGet)));
    }
  }
}
